import { useTranslate } from "src/i18n";

export const useProductPriceSourceTranslate = () => {
  const { t } = useTranslate();

  return {
    title_price: t("product_page.title_price", "Узнать цену товара"),
    update_price: t("product_page.update_price", "Обновить цены"),
    select_platform_hint: t(
      "product_page.select_platform_hint",
      "Нажмите на платформу, чтобы загрузить цену",
    ),
    price_age: {
      justNow: t("product_page.price_age.just_now", "только что"),
      ago: t("product_page.price_age.ago", "назад"),
      minutes: [
        t("product_page.price_age.minute_one", "минуту"),
        t("product_page.price_age.minute_few", "минуты"),
        t("product_page.price_age.minute_many", "минут"),
      ] as [string, string, string],
      hours: [
        t("product_info.delivery_hour_one", "час"),
        t("product_info.delivery_hour_few", "часа"),
        t("product_info.delivery_hour_many", "часов"),
      ] as [string, string, string],
      days: [
        t("product_info.delivery_day_one", "день"),
        t("product_info.delivery_day_few", "дня"),
        t("product_info.delivery_day_many", "дней"),
      ] as [string, string, string],
    },
    price_loaded_ago: (age: string) =>
      t("product_page.price_loaded_ago", "Цены получены {age}", { age }),
    unavailable_platforms: (platforms: string) =>
      t(
        "product_page.unavailable_platforms",
        "Цены {platforms} сейчас недоступны — площадка не отдаёт данные",
        { platforms },
      ),
  };
};
